import React, {FC} from 'react';
import classNames from 'classnames';
import {Tab, Tabs} from 'components/Tabs';
import {BG} from 'constants/index';

import * as styles from './styles.module.scss';

interface PanelWithTabsProps {
  titles: string;
  bg?: BG
  children: React.ReactElement[];
}

const PanelWithTabs: FC<PanelWithTabsProps> = ({children, bg, titles}) => {
	const tabs = titles?.split('||') || [];
	if (tabs.length !== children.length) {
		return (
			<div className={styles.panelError}>
				<p>
					Number of titles ({tabs.length}) do not
					match number of tabs ({children.length})
				</p>
				<p>
					Please separate titles like
					so: 'Title 1||Title 2||Title 3'
				</p>
			</div>
		);
	}

	// Feed background color to children
	const updatedChildren = React.Children.map(children, (child) =>
		React.cloneElement(child, {bg: bg})
	);

	return (
		<div className={classNames({
			[styles.wrapper]: true,
			[styles.dark]: bg === BG.dark,
			[styles.transparent]: bg === BG.transparent,
		})}>
			<div className={styles.panelWithTabs}>
				<Tabs
					hashToUrl={false}
					darkBg={bg === BG.dark}
				>
					{tabs.map((tab, i) => (
						<Tab
							key={i}
							title={tab}
							hash={tab}
							className={styles.tab}
							titleClassName={styles.title}
						>
							{updatedChildren[i]}
						</Tab>
					))}
				</Tabs>
			</div>
		</div>
	);
};

export default PanelWithTabs;
